mutation Inertia_UpdateOrder($orderId: ID!, $officerId: ID, $description: String, $externalFileNumber: String, $verificationEnabled: Boolean, $documentEmailEnabled: Boolean) {
  updateOrder(input: { orderId: $orderId, officerId: $officerId, description: $description, externalFileNumber: $externalFileNumber, verificationEnabled: $verificationEnabled, documentEmailEnabled: $documentEmailEnabled }) {
    order {
      id
      gid
    }
    errors
  }
}